import { render, staticRenderFns } from "./ModalAddObservationApplicant.vue?vue&type=template&id=27a199e4&"
import script from "./ModalAddObservationApplicant.vue?vue&type=script&lang=js&"
export * from "./ModalAddObservationApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports